import { UseFormReturn, ControllerRenderProps, FieldPath, FieldValues } from 'react-hook-form';
import { FormField, FormItem, FormControl, FormMessage } from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/badge';

interface RadioFieldProps<TFieldValues extends FieldValues = FieldValues> {
  form: UseFormReturn<TFieldValues>;
  name: FieldPath<TFieldValues>;
  options: {
    value: string;
    label: string;
    badge?: string;
  }[];
}

export const RadioField = <TFieldValues extends FieldValues = FieldValues>({
  form,
  name,
  options
}: RadioFieldProps<TFieldValues>) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({
        field
      }: {
        field: ControllerRenderProps<TFieldValues, FieldPath<TFieldValues>>;
      }) => (
        <FormItem>
          <FormControl>
            <RadioGroup
              className="flex flex-col gap-4"
              value={field.value as string}
              onValueChange={(value: string) => {
                field.onChange(value);
              }}
            >
              {options.map((option) => (
                <div key={option.value} className="flex items-center space-x-2">
                  <RadioGroupItem value={option.value} id={`${name}-${option.value}`} />
                  <Label htmlFor={`${name}-${option.value}`}>
                    {option.label}
                    {option.badge && <Badge>{option.badge}</Badge>}
                  </Label>
                </div>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
